function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 12 15"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4.752.466C4.974.182 5.321 0 5.714 0a1.215 1.215 0 01.91.409l4.36 4.841a1.206 1.206 0 01-.099 1.707 1.213 1.213 0 01-1.708-.081L6.93 4.379v8.818c0 .664-.54 1.203-1.215 1.203A1.214 1.214 0 014.5 13.197V4.379L2.25 6.876c-.44.49-1.209.53-1.708.08A1.206 1.206 0 01.445 5.25L4.752.466z",
  fill: "#969EA2"
}));